import { toLower } from 'lodash/fp';
import { getContainer, getResolveRoute } from '@mews-commander/legacy-app-instance';
import { SearchResult, SimpleSearchResultsProps } from './types';

export const getSimpleSearchResult = ({
    routeName,
    titleKey,
    id,
    description,
    params = {},
}: SimpleSearchResultsProps): SearchResult => {
    const { appLocalizationComponent } = getContainer()();
    const { localizeText } = appLocalizationComponent;

    const title = localizeText(titleKey);
    return {
        id: id || routeName,
        title,
        description,
        searchValue: toLower(`${title}${description ? ` ${description}` : ''}`),
        url: getResolveRoute()(routeName, params),
    };
};
